<template>
  <div
      class="fullscreen-section"
      :style="{
          background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.35), rgba(0, 0, 0, 0.35)), url(\'/images/main-banner.jpg\') content-box no-repeat',
          backgroundSize: 'cover'
      }"
  >
      <div class="fullscreen-section__content container --container-80">
        <h1 class="fullscreen-section__title" v-html="languageEng ? 'Rent a car in Batumi with delivery today' : 'Арендуй авто в Батуми с доставкой уже сегодня'"></h1>

        <FullscreenSearchForm :languageEng="languageEng"/>

        <div
            @click="scrollTo('#our_features')" 
            class="fullscreen-section__scroll"
        >
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.8584 14.1083L20.0001 28.25L34.1417 14.1083L31.7851 11.75L20.0001 23.5367L8.21506 11.75L5.8584 14.1083Z" fill="white" fill-opacity="0.7"/>
          </svg>
        </div>
      </div>
  </div>

  <!-- Our Featurer -->
  <section class="section" id="our_features">
    <div class="container">
      <h2 class="section-title">{{ languageEng ? 'OUR FEATURES' : 'НАШИ ОСОБЕННОСТИ' }}</h2>
      <p class="section-title-description">
        {{ languageEng ? 'The best car rental deals in Batumi.  Get ready for high-level service and professional work of our specialists.  You can rent your car with guaranteed value for money.  Find exactly what you are looking for.  Book a car now and save time and money.' : 'Лучшие предложения по аренде автомобилей в Батуми.  Вас ждут сервис на высоком уровне и профессиональный подход к работе наших специалистов.  Вы можете арендовать свой автомобиль с гарантированным соотношением цены и качества.  Найдите именно то, что вы ищете.  Забронируйте авто сейчас и сэкономьте время и деньги.' }}
      </p>
      <div class="section__content">
        <ul class="our-features-list">
          <li class="our-features__item">
            <div class="our-features__icon">
              <svg class="our-features__icon" width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M31.75 58.8566L15.25 42.3566L19.9633 37.6433L31.755 49.4216L31.75 49.4266L60.0333 21.1433L64.7467 25.8566L36.4633 54.1433L31.7533 58.8533L31.75 58.8566Z" fill="#CF201B" fill-opacity="0.8"/>
              </svg>
            </div>
            <p class="our-features__name">{{ languageEng ? 'VALUE FOR MONEY and quality' : 'ВЫГОДНОЕ СООТНОШЕНИЕ ЦЕНЫ и качества.' }}</p>
          </li>
          <li class="our-features__item">
            <div class="our-features__icon">
              <svg class="our-features__icon" width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M39.96 80C17.8738 79.9779 -0.0147023 62.0595 9.06736e-06 39.9733C0.0147386 17.8872 17.9271 -0.00735017 40.0133 2.26489e-06C62.0995 0.00735923 80 17.9138 80 40C79.9867 62.1015 62.0615 80.0088 39.96 80ZM8.00001 40.688C8.18927 58.2929 22.5644 72.4382 40.1702 72.344C57.7759 72.2489 71.9982 57.95 71.9982 40.344C71.9982 22.738 57.7759 8.43908 40.1702 8.34397C22.5644 8.24981 8.18927 22.395 8.00001 40V40.688ZM44 60H36V52H44V60ZM44 44H36V20H44V44Z" fill="#2E3A59"/>
              </svg>
            </div>
            <p class="our-features__name">{{languageEng ? 'Our cars without special colors and logos' : 'Наши Машины без специальных окрасов и логотипов' }} </p>
          </li>
          <li class="our-features__item">
            <div class="our-features__icon">
              <svg width="89" height="80" viewBox="0 0 89 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M44.4925 80H44.2656C43.6028 79.9504 42.9723 79.6939 42.4635 79.2667C42.3242 79.1484 42.1961 79.0175 42.0809 78.8756L0.745197 29.6578C0.422878 29.2899 0.195304 28.849 0.0822243 28.3733C0.0822243 28.3156 0.0555274 28.2578 0.0421789 28.2C-0.0838723 27.4555 0.0749527 26.6908 0.487127 26.0578L0.571667 25.9333L16.7233 3.11111C16.7811 3.02222 16.839 2.94222 16.9057 2.87111C17.3782 2.3103 18.0337 1.93412 18.7567 1.80889C18.8804 1.79005 19.0053 1.77965 19.1305 1.77778L44.27 0H44.4925H44.7105L69.8546 1.77778C69.9936 1.78564 70.1319 1.80347 70.2684 1.83111C71.0617 1.97863 71.7668 2.42796 72.235 3.08444L88.4178 25.9467C88.4513 25.991 88.4825 26.0369 88.5112 26.0844C88.8817 26.6511 89.0495 27.3261 88.9873 28C88.9685 28.1727 88.9358 28.3437 88.8895 28.5111C88.7678 28.9372 88.5518 29.3306 88.2576 29.6622L46.9086 78.8711C46.8398 78.9573 46.7655 79.039 46.6861 79.1156C46.4263 79.3676 46.1254 79.5736 45.7962 79.7244C45.5261 79.8462 45.2399 79.9286 44.9464 79.9689C44.796 79.9896 44.6443 80 44.4925 80ZM26.4543 30.7156L44.4925 69.6133L62.5307 30.7156H26.4543ZM69.3473 30.7156L57.0578 57.2178L79.3053 30.7156H69.3473ZM9.66641 30.7156L31.9138 57.2178L19.6377 30.7156H9.66641ZM71.9369 13.3067L70.7801 24.6444H79.9549L71.9369 13.3067ZM44.4925 8.30667L30.5745 24.6444H58.4105L44.4925 8.30667ZM17.0481 13.3067L9.03013 24.6444H18.205L17.0481 13.3067ZM51.0644 6.53778L64.7421 22.5956L66.295 7.60444L51.0644 6.53778ZM37.9117 6.53778L22.69 7.60444L24.2251 22.5956L37.9117 6.53778Z" fill="#2E3A59"/>
              </svg>
            </div>
            <p class="our-features__name">{{ languageEng ? 'Convenient car delivery service' : 'Удобный сервис доставки авто' }}</p>
          </li>
        </ul>
      </div>
    </div>
  </section>

  <!--  Our Offers AND Discounts -->
  <section class="section" id="our_offers_and_discounts">
    <div class="container">
      <h2 class="section-title">{{languageEng ? 'OUR OFFERS AND DISCOUNTS' : 'НАШИ ПРЕДЛОЖЕНИЯ И СКИДКИ' }}</h2>
      <p class="section-title-description">
        {{languageEng ? 'Find our car rent Offers and Discounts' : 'Ознакомьтесь с нашими предложениями и скидками по аренде автомобилей' }}
      </p>
      <div class="section__content">

        <OffersList
            :isMobile="isMobile"
            :offers_list="offers_list"
        />
      </div>
    </div>
  </section>
  <!--  Our Offers AND Discounts -->

  <!-- Our Top Car Hire Agencies -->
  <section class="section pb-0">
    <div class="container --container-80">
      <h2 class="section-title">{{ languageEng ? 'DISCOVER THE BEST PLACES IN BATUMI WITH GEauto rent a car' : 'ОТКРОЙТЕ ЛУЧШИЕ МЕСТА В БАТУМИ С GEauto rent a car' }}</h2>
      <p class="section-title-description">
        {{languageEng ? 'Write your road trip story' : 'Напишите свою историю автопутешествия' }}
      </p>
      <div class="section__content">
        <AggensSlider :languageEng="languageEng"
            :isMobile="isMobile"
        />
      </div>
    </div>
  </section>
  <!-- Our Top Car Hire Agencies -->
  <!-- You have questions? -->
  <section class="section" id="question">
    <div class="container --flex-row">
      <div class="information__content">
        <h2 class="section-title left">{{ languageEng ? 'YOU HAVE QUESTIONS?' : 'У ВАС ЕСТЬ ВОПРОСЫ?' }}</h2>
        <p class="section-description">{{ languageEng ? 'Contact us using the provided contact details. GEauto rent a car specialists will be happy to answer you. You can also visit the car rental office in Batumi at the specified address.' : 'Свяжитесь с нами по указанным контактным данным. Специалисты GEauto rent a car с удовольствием ответят вам. Так же вы можете обратиться в офис автопроката в Батуми по указанному адресу.' }}</p>
        <div class="information-list">
          <a
              href="https://goo.gl/maps/PPJ4XWFppBuVfUpM8"
              target="_blank"
              class="information__item"
          >
            <svg class="information__item-icon" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 9.99977C13.6193 9.99977 12.5 11.1191 12.5 12.4998C12.5 13.8805 13.6193 14.9998 15 14.9998C16.3807 14.9998 17.5 13.8805 17.5 12.4998C17.5 11.1191 16.3807 9.99977 15 9.99977Z" fill="black"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M10.625 21.836C11.9577 23.4267 13.4212 24.903 15 26.2498C16.5788 24.903 18.0423 23.4267 19.375 21.836C21.375 19.4473 23.75 15.8898 23.75 12.4998C23.7574 10.1777 22.8356 7.94927 21.19 6.31101C18.6876 3.80631 14.9224 3.05651 11.6513 4.4115C8.38031 5.7665 6.24823 8.95919 6.25 12.4998C6.25 15.8898 8.625 19.4473 10.625 21.836ZM8.75 12.4998C8.75414 9.04969 11.5499 6.25389 15 6.24976C18.4501 6.25389 21.2459 9.04969 21.25 12.4998C21.25 13.956 20.5913 16.4798 17.4575 20.236C16.6841 21.1571 15.8638 22.0378 15 22.8748C14.1363 22.0368 13.3164 21.1548 12.5438 20.2323C9.40875 16.481 8.75 13.9573 8.75 12.4998Z" fill="black"/>
            </svg>
            54 Parnavaz Mepe St, Batumi 6010, Georgia
          </a>
          <a
              href="tel:995568946240"
              class="information__item"
          >
            <svg class="information__item-icon" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.8786 5.32152L10.9501 5.69291V5.69291L11.8786 5.32152ZM13.1964 8.6161L14.1249 8.24471L13.1964 8.6161ZM12.7958 11.145L13.564 11.7852L12.7958 11.145ZM12.0866 11.9961L12.8548 12.6363L12.0866 11.9961ZM12.2394 15.3644L11.5322 16.0715H11.5322L12.2394 15.3644ZM14.6357 17.7607L15.3428 17.0535L14.6357 17.7607ZM18.0039 17.9134L17.3637 17.1452L18.0039 17.9134ZM18.855 17.2042L19.4951 17.9724L19.4951 17.9724L18.855 17.2042ZM21.3839 16.8036L21.0125 17.732L21.3839 16.8036ZM24.6785 18.1214L25.0499 17.1929H25.0499L24.6785 18.1214ZM6.11842 4.75H9.55742V2.75H6.11842V4.75ZM10.9501 5.69291L12.268 8.98749L14.1249 8.24471L12.8071 4.95013L10.9501 5.69291ZM12.0276 10.5049L11.3183 11.3559L12.8548 12.6363L13.564 11.7852L12.0276 10.5049ZM11.5322 16.0715L13.9285 18.4678L15.3428 17.0535L12.9465 14.6572L11.5322 16.0715ZM18.6441 18.6817L19.4951 17.9724L18.2148 16.436L17.3637 17.1452L18.6441 18.6817ZM21.0125 17.732L24.3071 19.0499L25.0499 17.1929L21.7553 15.8751L21.0125 17.732ZM25.25 20.4426V23.8816H27.25V20.4426H25.25ZM23.8816 25.25C13.3155 25.25 4.75 16.6845 4.75 6.11842H2.75C2.75 17.7891 12.2109 27.25 23.8816 27.25V25.25ZM25.25 23.8816C25.25 24.6373 24.6373 25.25 23.8816 25.25V27.25C25.7419 27.25 27.25 25.7419 27.25 23.8816H25.25ZM24.3071 19.0499C24.8766 19.2777 25.25 19.8292 25.25 20.4426H27.25C27.25 19.0114 26.3787 17.7244 25.0499 17.1929L24.3071 19.0499ZM19.4951 17.9724C19.9184 17.6197 20.501 17.5274 21.0125 17.732L21.7553 15.8751C20.5617 15.3976 19.2024 15.613 18.2148 16.436L19.4951 17.9724ZM13.9285 18.4678C15.2086 19.7478 17.2534 19.8405 18.6441 18.6817L17.3637 17.1452C16.7677 17.6419 15.8913 17.6021 15.3428 17.0535L13.9285 18.4678ZM11.3183 11.3559C10.1595 12.7466 10.2522 14.7914 11.5322 16.0715L12.9465 14.6572C12.3979 14.1087 12.3581 13.2323 12.8548 12.6363L11.3183 11.3559ZM12.268 8.98749C12.4726 9.49904 12.3803 10.0816 12.0276 10.5049L13.564 11.7852C14.387 10.7976 14.6024 9.43833 14.1249 8.24471L12.268 8.98749ZM9.55742 4.75C10.1708 4.75 10.7223 5.12343 10.9501 5.69291L12.8071 4.95013C12.2756 3.62133 10.9886 2.75 9.55742 2.75V4.75ZM6.11842 2.75C4.25809 2.75 2.75 4.25809 2.75 6.11842H4.75C4.75 5.36266 5.36266 4.75 6.11842 4.75V2.75Z" fill="#14181F"/>
            </svg>
            +995 568 946 240
          </a>
          <a
              href="mailto:contact@rentauto24.ge"
              class="information__item"
          >
            <svg class="information__item-icon --stroke" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M25 6.25H5C4.30964 6.25 3.75 6.80964 3.75 7.5V22.5C3.75 23.1904 4.30964 23.75 5 23.75H25C25.6904 23.75 26.25 23.1904 26.25 22.5V7.5C26.25 6.80964 25.6904 6.25 25 6.25Z" stroke="#14181F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M3.75 7.5L15.3214 16.25L26.25 7.5" stroke="#14181F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            contact@rentauto24.ge
          </a>
          <div
              href="mailto:contact@rentauto24.ge"
              class="information__item"
          >
            <svg class="information__item-icon --stroke" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 26.25C21.2132 26.25 26.25 21.2132 26.25 15C26.25 8.7868 21.2132 3.75 15 3.75C8.7868 3.75 3.75 8.7868 3.75 15C3.75 21.2132 8.7868 26.25 15 26.25Z" stroke="#14181F" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M15 8.75V15H21.25" stroke="#14181F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            {{ languageEng ? '24 hours' : 'Круглосуточно'}}
          </div>
        </div>
      </div>
      <div class="information__social">
        <a href="https://instagram.com/rentauto24.ge?igshid=YmMyMTA2M2Y=" target="_blank" class="social">
          <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 40C0 17.9086 17.9086 0 40 0C62.0914 0 80 17.9086 80 40C80 62.0914 62.0914 80 40 80C17.9086 80 0 62.0914 0 40Z" fill="white"/>
            <mask id="mask0_11_235" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="80" height="80">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M0 40C0 17.9086 17.9086 0 40 0C62.0914 0 80 17.9086 80 40C80 62.0914 62.0914 80 40 80C17.9086 80 0 62.0914 0 40Z" fill="white"/>
            </mask>
            <g mask="url(#mask0_11_235)">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M39.9987 18.6665C34.208 18.6665 33.4807 18.6919 31.2055 18.7954C28.9344 18.8994 27.3842 19.259 26.0277 19.7865C24.6246 20.3314 23.4344 21.0603 22.2486 22.2465C21.0619 23.4323 20.333 24.6226 19.7863 26.0252C19.2574 27.3821 18.8974 28.9328 18.7952 31.2031C18.6934 33.4787 18.6667 34.2062 18.6667 40.0001C18.6667 45.7939 18.6925 46.5188 18.7956 48.7944C18.9001 51.0655 19.2596 52.6157 19.7868 53.9722C20.3321 55.3753 21.061 56.5656 22.2472 57.7513C23.4326 58.938 24.6228 59.6687 26.025 60.2136C27.3824 60.7412 28.9331 61.1007 31.2038 61.2047C33.4793 61.3083 34.206 61.3336 39.9994 61.3336C45.7937 61.3336 46.5186 61.3083 48.7942 61.2047C51.0653 61.1007 52.6173 60.7412 53.9747 60.2136C55.3773 59.6687 56.5658 58.938 57.7512 57.7513C58.9378 56.5656 59.6667 55.3753 60.2134 53.9726C60.7379 52.6157 61.0979 51.0651 61.2045 48.7948C61.3067 46.5192 61.3334 45.7939 61.3334 40.0001C61.3334 34.2062 61.3067 33.4791 61.2045 31.2035C61.0979 28.9324 60.7379 27.3821 60.2134 26.0257C59.6667 24.6226 58.9378 23.4323 57.7512 22.2465C56.5645 21.0599 55.3778 20.331 53.9733 19.7865C52.6133 19.259 51.0622 18.8994 48.7911 18.7954C46.5159 18.6919 45.7913 18.6665 39.9987 18.6665ZM38.0883 22.511C38.4599 22.5104 38.8596 22.5106 39.291 22.5108L40.0021 22.511C45.6981 22.511 46.3733 22.5314 48.6226 22.6337C50.7026 22.7288 51.8315 23.0763 52.5835 23.3683C53.5791 23.755 54.2889 24.2172 55.0351 24.9639C55.7818 25.7106 56.244 26.4217 56.6316 27.4173C56.9236 28.1684 57.2716 29.2973 57.3663 31.3773C57.4685 33.6262 57.4907 34.3018 57.4907 39.9952C57.4907 45.6886 57.4685 46.3641 57.3663 48.613C57.2711 50.6931 56.9236 51.822 56.6316 52.5731C56.2449 53.5686 55.7818 54.2775 55.0351 55.0238C54.2884 55.7704 53.5796 56.2327 52.5835 56.6193C51.8324 56.9127 50.7026 57.2594 48.6226 57.3545C46.3737 57.4567 45.6981 57.4789 40.0021 57.4789C34.3056 57.4789 33.6305 57.4567 31.3815 57.3545C29.3015 57.2585 28.1726 56.9109 27.4202 56.6189C26.4246 56.2322 25.7135 55.77 24.9668 55.0233C24.2201 54.2767 23.7579 53.5673 23.3704 52.5713C23.0784 51.8202 22.7303 50.6913 22.6357 48.6113C22.5335 46.3624 22.513 45.6868 22.513 39.9898C22.513 34.2929 22.5335 33.6209 22.6357 31.372C22.7308 29.292 23.0784 28.163 23.3704 27.411C23.757 26.4155 24.2201 25.7044 24.9668 24.9577C25.7135 24.211 26.4246 23.7488 27.4202 23.3612C28.1722 23.0679 29.3015 22.7212 31.3815 22.6257C33.3496 22.5368 34.1122 22.5101 38.0883 22.5057V22.511ZM48.8297 28.6124C48.8297 27.1986 49.9764 26.0532 51.3898 26.0532V26.0524C52.8031 26.0524 53.9498 27.199 53.9498 28.6124C53.9498 30.0257 52.8031 31.1724 51.3898 31.1724C49.9764 31.1724 48.8297 30.0257 48.8297 28.6124ZM40.0016 29.0444C33.9516 29.0446 29.0464 33.9499 29.0464 40.0001C29.0464 46.0503 33.9518 50.9535 40.0021 50.9535C46.0524 50.9535 50.956 46.0503 50.956 40.0001C50.956 33.9498 46.0519 29.0444 40.0016 29.0444ZM47.1133 40.0001C47.1133 36.0725 43.9292 32.8889 40.0021 32.8889C36.0745 32.8889 32.8909 36.0725 32.8909 40.0001C32.8909 43.9272 36.0745 47.1112 40.0021 47.1112C43.9292 47.1112 47.1133 43.9272 47.1133 40.0001Z" fill="#CF201B" fill-opacity="0.8"/>
            </g>
          </svg>
          <span class="social-name">Instagram</span>
        </a>
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 3.75V26.25" stroke="#14181F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M21.25 20L15 26.25L8.75 20" stroke="#14181F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <div class="social qr-code">
          <img src="/images/qr_code.png" alt="instagram-qr">
          <span class="social-name">Qr-code</span>
        </div>
      </div>
    </div>
  </section>
  <!-- You have questions? -->
  <!-- Contact us -->
  <section
      class="fullscreen-section"
      :style="{
          background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.35), rgba(0, 0, 0, 0.35)), url(\'/images/feedback-banner.jpg\') content-box no-repeat',
          backgroundSize: 'cover'
      }"
  >
    <div class="fullscreen-section__content container">
      <ContactUs :languageEng="languageEng"/>
    </div>
  </section>
  <!-- Contact us -->

  <!-- Footer -->
  <Footer :languageEng="languageEng"/>
  <!-- Footer  -->
</template>


<script>
import {defineComponent} from "vue";

// Компоненты
import FullscreenSearchForm from "@/components/forms/FullscreenSearchForm";
import OffersList from "@/components/offers/OffersList";
import AggensSlider from "@/components/aggensSlider/AggensSlider";
import ContactUs from "@/components/forms/ContactUs";
import Footer from '@/components/Footer'
// Utils
import {scrollTo} from "@/utills/scroll";

export default defineComponent({
  name : 'Index',
  components: {
    FullscreenSearchForm, OffersList,
    AggensSlider, ContactUs, Footer,
  },
  props: {
    isMobile: {
      type : Boolean
    },
    languageEng: {
      type: [Boolean]
    }
  },
  setup(props) {
    const offers_list = [
      {
        id : 1,
        description :  props.languageEng ? 'Risks will be covered by CASCO' : 'Риски покрывет КАСКО',
        image: '/images/offers/offers_1.jpg',
        end : '2022-07-22',
        another: {
          status: props.languageEng ? 'New' : 'Новинка',
        },
        link : 'https://vk.com/'
      },
      {
        id : 2,
        description : props.languageEng ? 'Risks will be covered by CASCO' : 'Риски покрывет КАСКО',
        image: '/images/offers/offers_2.jpg',
        end : '2022-07-22',
        another: {
          status: props.languageEng ? 'New' : 'Новинка',
        },
        link : 'https://vk.com/'
      },
      {
        id : 3,
        description: props.languageEng ? 'Risks will be covered by CASCO' : 'Риски покрывет КАСКО',
        image: '/images/offers/offers_3.jpg',
        another: {
          status: props.languageEng ? 'New' : 'Новинка',
        },
        end : '2022-07-22',
        link : 'https://vk.com/'
      },
    ];
    return {
      scrollTo,
      offers_list
    }
  }
})
</script>

<style scoped src="../assets/styles/index.css">

</style>


